<template>
  <div>
    <!-- Campaign Contents -->
    <div
      class="row flex-row flex-nowrap justify-content-center"
      style="overflow-x: hidden"
    >
      <!-- Left Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->

      <!-- Content Card -->
      <div class="card shadow customs-card mx-2">
        <!-- Campaign Content Name -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p
            class="text-center mb-0 font-weight-bold headline text-white"
            style="word-wrap: break-word"
            v-html="campaign.name"
          >
            <!--{{ campaign.name }}-->
          </p>
        </div>

        <div class="card-body p-4 d-flex align-items-center justify-content-center">
          <!-- Campaign Image -->
          <div class="row">
            <div class="col-10 p-0 mx-auto">
              <img
                :src="campaign.image"
                :alt="campaign.id"
                class="img-fluid mx-auto d-block"
              />
            </div>
          </div>
        </div>

        <div class="card-footer border-0 mb-4 mx-2" style="border-radius: inherit; background-color: #e9ecef !important;">
          <!-- Campaign Name -->
          <p class="m-0 mb-1 text-center font-weight-bold text-bold text-color">
            {{ campaign.contentName }}
          </p>

          <p class="m-0 text-center text text-color">
            3回カードを引いて3連続で当たりが出たら…
          </p>

          <!-- Campaign Description -->
          <p class="m-0 text-center text text-color">
            <span style="word-wrap:break-word" v-html="campaign.description"></span>
            <!--{{ campaign.description }}-->
          </p>

          <p class="m-0 mb-1 text-center text text-color mt-4">
            ＼ハズレてもLINEシェアしてリトライできるよ！／
          </p>

          <!-- Campaign Button -->
          <div class="mt-2 mb-1">
            <button
              type="button"
              @click="startGame"
              class="btn btn-block button text-color rounded-pill"
            >
              <p class="m-0 font-weight-bold text-bold text-color">
                ゲームスタート！
              </p>
            </button>
          </div>
        </div>
      </div>

      <!-- Right Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->
    </div>

    <!-- Cautions Label and Cautions Details -->
    <cautions :cautions="campaign.cautions"></cautions>
  </div>
</template>

<script>
import {
  getCampaignId,
  getCampaignContents,
  setCampaignContents,
  removeCampaignContents,
  setIsShareable,
  removeIsShareable,
  setCampaignCautions,
  getCampaignImageContents,
  setCampaignImageContents,
  removeCampaignImageContents,
  setLinkShare,
  setIsRetry,
  setSharedLine
} from "@/utils/campaign";
import { setErrorMessage } from "@/utils/error";
import { getUserAgentMobile } from "@/utils/auth";
import {checkShareLine, getCampaign} from "@/api/campaign";
import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      campaign: {
        id: null,
        name: null,
        contentName: null,
        description: null,
        image: null,
        cautions: null,
        isOpening: false,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    // Set retry status
    setIsRetry(0);
    // Get Link Share on LINE of campaign
    checkShareLine({
        campaign_id: getCampaignId(),
        user_agent_mobile: getUserAgentMobile()
      }).then((data) => {
          if (data.result.url) {
            setLinkShare(data.result.url);
            setSharedLine(data.result.share);

          }
        });
    // get campaign id from cookies
    const query = {
      campaign_id: getCampaignId(),
    };

    // Remove campaign contents from cookies
    if (getCampaignContents()) {
      removeCampaignContents();
    }

    // Remove campaign isShareable from cookies
    removeIsShareable();

    // Remove campaign image contents from cookies
    if (getCampaignImageContents()) {
      removeCampaignImageContents();
    }

    // get campaign from api and set to data
    // console.log('query:' + JSON.stringify(query));
    getCampaign(query)
      .then((response) => {
        if (response.status === "success") {
          return next((vm) => {
            // check campaign contents existence
            if (
              response.result.campaign.contents ||
              response.result.campaign.content_images
            ) {
              if (response.result.campaign.contents) {
                // set campaign contents to cookies
                setCampaignContents(response.result.campaign.contents);
              }

              if (response.result.campaign.content_images) {
                // set campaign image contents to cookies
                setCampaignImageContents(response.result.campaign.content_images);
              }

              // set is_shareable to cookies
              setIsShareable(response.result.campaign.is_shareable)

              // set campaign isOpening status to true
              vm.setCampaignIsOpeningStatus(true);
            } else {
              //set campaign isOpening status to false
              vm.setCampaignIsOpeningStatus(false);
            }

            // set campaign cautions cookies function
            setCampaignCautions(response.result.campaign.caution);

            // set campaign data (id, name, contentName, description, image, cautions)
            vm.setCampaign(response);
          });
        } else {
          throw new Error(response);
        }
      })
      .catch((error) => {
        console.error(JSON.stringify(error));
        setErrorMessage(error.statusCode);
        this.$router.push( {name: "Error"});
      });
  },
  methods: {
    setCampaign(response) {
      this.campaign.id = getCampaignId();
      this.campaign.name = response.result.campaign.name || "";
      if (response.result.campaign.contents) {
        this.campaign.contentName = response.result.campaign.contents.name;
      } else {
        this.campaign.contentName = "”ゲームスタート！”で抽選開始！";
      }
      this.campaign.description = response.result.campaign.description || "";
      this.campaign.image =
        process.env.BASE_API + response.result.campaign.image_of_winners;
      this.campaign.cautions = response.result.campaign.caution || "";
    },
    setCampaignIsOpeningStatus(status) {
      this.campaign.isOpening = status;
    },
    startGame() {
      if (this.campaign.isOpening) {
        this.$router.push({ name: "Game" });
      } else {
        this.$router.push("/campaign-ended");
      }
    },
  },
};
</script>

<style scoped>
/* ボタン本体 */
.btn {
  display: inline-block;
  padding: 0.8em 3em;
  background-color: #ffd150; /* 背景色 */
  box-shadow: 0 5px 0 #ffc41d; /* 影の太さ・色 */
  border-radius: 60px;
  color: #fff;
  cursor: pointer;
  text-decoration: none; /* 文字の下線を消す */
}

/* クリック時 */
.btn:active {
  box-shadow: none;
  transform: translateY(5px);
}
</style>
